const browseContactReduces = (
  state = {
    fromDate: "",
    toDate: "",
    projectNameSelected: [],
    propertyTypeSelected: [],
    budgetFromSelected: [],
    budgetToSelected:[],
    requirementTypeSelected:[],
    leadSourceSelected: [],
    leadTypeSelected: [],
    leadAssigneeSelected: [],
    selectedBrowseTemplate:{}
  },
  action: {
    type:
      | "SET_FROMDATE"
      | "SET_TODATE"
      | "SET_PROJECTNAME"
      | "SET_PROPERTYTYPE"
      | "SET_REQUIREMENT_TYPE"
      | "SET_BUDGE_FROM"
      | "SET_BUDGE_TO"
      | "SET_LEADSOURCE"
      | "SET_LEADTYPE"
      | "SET_LEADASSIGNEE"
      |"SET_BROWSE_TEMPLATE";
    payload: any;
  }
) => {
  switch (action.type) {
    case "SET_FROMDATE":
      return { ...state, fromDate: action.payload };
    case "SET_TODATE":
      return { ...state, toDate: action.payload };
    case "SET_PROJECTNAME":
      return { ...state, projectNameSelected: action.payload };
    case "SET_PROPERTYTYPE":
      return { ...state, propertyTypeSelected: action.payload };
      case "SET_REQUIREMENT_TYPE":
      return { ...state, requirementTypeSelected: action.payload };
    case "SET_BUDGE_FROM":
      return { ...state, budgetFromSelected: action.payload };
      case "SET_BUDGE_TO":
        return { ...state, budgetToSelected: action.payload };
    case "SET_LEADSOURCE":
      return { ...state, leadSourceSelected: action.payload };
    case "SET_LEADTYPE":
      return { ...state, leadTypeSelected: action.payload };
    case "SET_LEADASSIGNEE":
      return { ...state, leadAssigneeSelected: action.payload };
      case "SET_BROWSE_TEMPLATE":
        return { ...state, selectedBrowseTemplate: action.payload };

    default:
      return state;
  }
};

export default browseContactReduces;
